import { ChatPreviewProps } from "@/common/types";
import { convertDateToStringWithTime } from "@/utils/date.util";
import { ScrollArea } from "@radix-ui/react-scroll-area";
import { useEffect, useRef } from "react";

const ChatPreview: React.FC<ChatPreviewProps> = ({
  chatPreview,
  heightToReduce = "176px",
}) => {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatPreview]);

  return (
    <ScrollArea className={`h-[calc(100vh-${heightToReduce})] overflow-auto`}>
      {chatPreview.map((message, idx) => (
        <div
          key={idx}
          className={`flex flex-col ${
            message.send_by_me ? "items-end" : "items-start"
          } py-3 px-4`}
        >
          <div className="text-sm bg-gray-100 text-gray-500 rounded-md py-2 px-4 w-fit max-w-[80%] flex flex-col items-end justify-between">
            <span className="text-black">{message.message}</span>
            <span className="ml-2 text-[10px] text-gray-500">
              {convertDateToStringWithTime(message.timestamp)}
            </span>
          </div>
        </div>
      ))}
      <div ref={bottomRef} />
    </ScrollArea>
  );
};

export default ChatPreview;
